import React from "react";

import styled from "@emotion/styled";

export const ErrorMessageP = styled.p`
    scroll-margin-top: calc((8vh * 1.1) + 50px);
    font-size: 12px;
    color: #05235f;
`;

const FormError = ({ className = "", message, gtag }) => {
    return <ErrorMessageP>{message}</ErrorMessageP>;
};

export default FormError;
